import { useEffect, useState, forwardRef } from 'react';

import styles from './New_DropDownComponent.module.css'

import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons'
import { GetMaxZIndex } from '../../utils/UtilitaryFunctions';

import New_InputTextComponent from './New_InputTextComponent';



const New_DropDownComponent = forwardRef((props, ref) => {

    var {
        focused = false, currentChoice, onChange, keyboardRef, placeHolder, width, options, elementsToShowNumber = 3, width, position, styleType = "POPUP", typeOfInput
    } = props;

    const [isOpen, setIsOpen] = useState(false)
    const [selectedOptions, setSelectedOptions] = useState(false)
    const [elementsToShow, setElementsToShow] = useState(false)


    useEffect(() => {
        setSelectedOptions(options);
        setElementsToShow(elementsToShowNumber);
        ref.current.currentChoice = currentChoice;
        ref.current.value = currentChoice ? currentChoice.name : "";
    }, [])

    useEffect(() => {
        if (selectedOptions.length > 3) {
            setElementsToShow(elementsToShowNumber);
        } else {
            setElementsToShow(selectedOptions.length);
        }
    }, [selectedOptions])

    const OnTextChanged = () => {
        if (ref.current.value) {
            let searchText = ref.current.value;
            searchText.toLowerCase();

            // am adaugat o sortare care verifica dupa index pentru a sorta dupa primele litere din tara prioritar - Veronika
            setSelectedOptions(
                options
                    .filter(element => element.name.toLowerCase().includes(searchText))
                    .sort((a, b) =>
                        a.name.toLowerCase().indexOf(searchText) - b.name.toLowerCase().indexOf(searchText)
                    )
            );
        } else {
            setSelectedOptions(options);
        }
    };

    useEffect(() => {
        ref.current.currentChoice = currentChoice;
        ref.current.value = currentChoice ? currentChoice.name : "";
    },[currentChoice])


    return (
        <div tabIndex="0" >
            <New_InputTextComponent focused={focused} onBlur={() => setIsOpen(false)} ref={ref} keyboardRef={keyboardRef} value={currentChoice ? currentChoice.name : ""} 
                placeHolder={placeHolder} iconPosition="right" withDelete={true} typeOfInput={typeOfInput}
                onChange={() => OnTextChanged()} onFocus={() => { setIsOpen(true); OnTextChanged(); }} styleType={styleType} width={width} height="80px" fontSize="40px"
                icon={byPrefixAndName.fal[isOpen ? "chevron-up" : "chevron-down"]} />

            {isOpen &&
                <div className={styles.optionsWindow} style={{ width: width, zIndex: GetMaxZIndex() + 1, height: elementsToShow * 85, position: position }}>
                    <div className={styles.scrollContent} style={{ width: width, zIndex: GetMaxZIndex() + 1 }}>
                        {selectedOptions.map((option) => (
                            <div key={option.value} className={ref.current.currentChoice?.name === option.name ? styles.optionSelected : styles.option} onMouseDown={() => {
                                ref.current.currentChoice = option;
                                ref.current.value = option.name;
                                onChange?.(option.name);
                            }}>
                                <div style={{ marginLeft: "10px" }}>{option.name}</div>
                            </div>
                        ))}
                    </div>
                </div>
            }

        </div>

    );

})

export default New_DropDownComponent;